/**
 * @generated SignedSource<<3c4dbd5ed0050cd0a1ad124f0beb122a>>
 * @relayHash 83830a7dd7d67ef7cddece618c01be41
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/409.0.0-2023-04-13T14:03:00.087Z/CustomsMessagingRendererQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomsMessagingRendererQuery$variables = {
  itemId?: string | null;
  shippingAddressId?: string | null;
  userId?: string | null;
};
export type CustomsMessagingRendererQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"CustomsMessagingBody_viewer">;
  };
};
export type CustomsMessagingRendererQuery = {
  response: CustomsMessagingRendererQuery$data;
  variables: CustomsMessagingRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shippingAddressId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomsMessagingRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomsMessagingBody_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomsMessagingRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userId"
              },
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "itemId"
              },
              {
                "kind": "Variable",
                "name": "shippingAddressId",
                "variableName": "shippingAddressId"
              }
            ],
            "concreteType": "DutiesClassification",
            "kind": "LinkedField",
            "name": "dutiesClassification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duties",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/409.0.0-2023-04-13T14:03:00.087Z/CustomsMessagingRendererQuery",
    "metadata": {},
    "name": "CustomsMessagingRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "111050ec454417a8900f800f843259ae";

export default node;
